'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const StatisticsPanelHelpers=require('../../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ThresholdStatusDonutDirective=function(_BaseControllerBacked){_inherits(ThresholdStatusDonutDirective,_BaseControllerBacked);function ThresholdStatusDonutDirective(){_classCallCheck(this,ThresholdStatusDonutDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ThresholdStatusDonutDirective,[{key:'controller',get:function()
{return ThresholdStatusDonutDirectiveController}},{key:'objectBindings',get:function()
{return['statusCounts','preventAnimations']}},{key:'template',get:function()
{
return`<svg id="{{::controller.panelId}}"></svg>`;
}}]);return ThresholdStatusDonutDirective}(BaseControllerBackedDirective);


const DefaultHeightAndWidth=100;
const ComponentPadding=10;
const InnerPadding=0;
const RingThickness=8;let

ThresholdStatusDonutDirectiveController=function(){
function ThresholdStatusDonutDirectiveController($scope,$timeout,$element,elementService){var _this2=this;_classCallCheck(this,ThresholdStatusDonutDirectiveController);
this._$scope=$scope;
this._$timeout=$timeout;
this._$element=$element;
this._elementService=elementService;
this._svgContainer=null;

this.preventAnimations=_.exists(this.preventAnimations)?this.preventAnimations:!1;

this.panelId='panel-'+Guid.create().toString();

const _debouncedRedraw=_.debounce(function(options){return $timeout(function(){return _this2._redraw(options)})},100);
const _redrawIfNew=function(newVal,oldVal){
if(!_.exists(newVal)||newVal===oldVal){
return;
}

_debouncedRedraw();
};

$scope.$watch('controller.statusCounts',_redrawIfNew);
$scope.$on('resize::resize',function(){return _debouncedRedraw({isResizing:!0})});

_debouncedRedraw();
}ThresholdStatusDonutDirectiveController.prototype.

_redraw=function _redraw(){let{isResizing=!1}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};
const componentHeightAndWidth=Math.max(100,this.parentWrapperElement.clientHeight)-ComponentPadding*2;

if(isResizing&&this._lastComponentHeightAndWidth&&componentHeightAndWidth===this._lastComponentHeightAndWidth){
return;
}

this._setupGraphs(componentHeightAndWidth);
this._setupInitialState(isResizing);
this._updateState(isResizing);

this._lastComponentHeightAndWidth=componentHeightAndWidth;
};ThresholdStatusDonutDirectiveController.prototype.





_setupGraphs=function _setupGraphs(componentHeightAndWidth){
if(!_.exists(this._svgContainer)){
this._svgContainer=d3.select(`#${this.panelId}`);

this._graphAreaGroup=this._svgContainer.append('g').
attr({class:'graph-area'});
}

this._svgContainer.
attr(componentHeightAndWidth).
style('width',`${componentHeightAndWidth}px`).
style('height',`${componentHeightAndWidth}px`);

this._graphAreaGroup.
attr('transform',`translate(${componentHeightAndWidth/2},${componentHeightAndWidth/2})`);

this._drawArc=d3.svg.arc().
outerRadius(componentHeightAndWidth/2-InnerPadding).
innerRadius(componentHeightAndWidth/2-InnerPadding-RingThickness/DefaultHeightAndWidth*componentHeightAndWidth);
};ThresholdStatusDonutDirectiveController.prototype.

_setupInitialState=function _setupInitialState(isResizing){
const formatted=_.toPairs(this.statusCounts).reverse().filter(function(_ref){let[type,count]=_ref;return count>0});

this._dataArcs=this._graphAreaGroup.
attr({class:'graph-area arc'}).
selectAll('path').
data(pie(formatted),function(d,i){return Math.random()});

this._dataArcs.
enter().
append('path').
attr({
d:this._drawArc,
class:function(d){return`${_getSegmentName(d).toLowerCase()}-threshold`}});


if(isResizing||this.preventAnimations){
this._dataArcs.
exit().
remove();
return;
}

this._dataArcs.
exit().
transition().duration(StatisticsPanelHelpers.DefaultTransitionDuration).
each('end',_removeElement);
};ThresholdStatusDonutDirectiveController.prototype.

_updateState=function _updateState(isResizing){
const drawArc=this._drawArc;

if(isResizing||this.preventAnimations){
this._dataArcs.
attr('d',drawArc);
return;
}

this._dataArcs.
transition().
duration(StatisticsPanelHelpers.DefaultTransitionDuration).
attrTween('d',function(d){
const interpolate=d3.interpolate({
startAngle:0,
endAngle:0},
d);

return function(t){
return drawArc(interpolate(t));
};
});
};_createClass(ThresholdStatusDonutDirectiveController,[{key:'parentWrapperElement',get:function(){return this._parentWrapperElement||(this._parentWrapperElement=this._elementService.selectElement(this._$element)[0].parentElement)}}]);return ThresholdStatusDonutDirectiveController}();


const _getSegmentName=function(d){return d.data[0]};

const pie=d3.layout.pie().
sort(null).
value(function(d){return d[1]});


function _removeElement(){
if(typeof this.remove=='function'){
return this.remove();
}

if(_.exists(this.parentNode)){
return this.parentNode.removeChild(this);
}


}

module.exports=ThresholdStatusDonutDirective;
//# sourceMappingURL=thresholdStatusDonutDirective.js.map
